import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { numberFormat } from "../../extends/NumberFormat";
import { RenderNotes } from "../../hooks/notes";
import PopoverButton from "../PopoverButton/PopoverButton";

const styles = (theme) => ({
  font: {
    fontSize: 16,
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
  },
  italic: {
    fontStyle: "italic",
    fontSize: 14,
  },
  fontNormal: {
    fontStyle: "normal",
  },
  marginTop: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 16,
    padding: "0px 0px 13px 13px",
  },
});

const Staff = (props) => {
  const { classes, staff, settings, pastEvent } = props;

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item xs={12}>
        <Grid container className={classes.border}>
          {staff.topNotes ? (
            <Grid item xs={12}>
              {RenderNotes(staff.topNotes, classes.italic)}
            </Grid>
          ) : null}

          {staff.topNotes ? (
            <Grid item xs={12}>
              <hr align="left" width="100%" />
            </Grid>
          ) : null}
          {staff.items && staff.items.length ? (
            staff.items.map((element, index) => {
              return (
                <Grid item xs={12} key={index}>
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <Typography variant="h6" className={classes.font}>
                        {element.jobTitle.name}
                      </Typography>
                    </Grid>
                    {!settings.isPriceOverridden ? (
                      settings.showSubtotals ? (
                        <Grid item>
                          <Typography variant="h6" className={classes.font}>
                            {numberFormat(element.total)}
                          </Typography>
                        </Grid>
                      ) : null
                    ) : null}
                  </Grid>

                  <Typography variant="subtitle1">
                    {settings.showQty ? `QTY: ${element.quantity},` : null}{" "}
                    {settings.showUnits
                      ? `Hrs: ${element.billedHours}, `
                      : null}
                    {settings.showUnitPrice
                      ? `Per Unit: ${numberFormat(element.billedRate)}`
                      : null}
                  </Typography>
                  {element.notes
                    ? RenderNotes(element.notes, classes.italic, true)
                    : null}
                  <hr align="left" width="100%" />
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography variant="subtitle1">No Staff</Typography>
            </Grid>
          )}

          {staff.bottomNotes ? (
            <Grid item xs={12}>
              {RenderNotes(staff.bottomNotes, classes.italic)}
            </Grid>
          ) : null}
          {!pastEvent ? (
            <Grid item xs={12} className={classes.marginTop}>
              <PopoverButton type={staff.newComment} />
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};

Staff.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Staff);
